import { BackToListingButtonContainer } from '@/microfrontends/listing/shared/containers/BackToListingButtonContainer';
import { SEOBlockByPin } from '@/microfrontends/listing/shared/containers/SEOBlockContainer';
import { VisitedOffersAnalytics } from '@/microfrontends/listing/shared/containers/VisitedOffersAnalytics';
import { ListingByPinContextProvider } from '@/microfrontends/listing/shared/context/ListingByPinContext';

import { useGetOffersByActivePinQuery } from '@/packages/query-state/shared/store/search-offers/v1/get-offers-by-pin/query';
import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';
import { useDisablePageScroll } from '@/packages/react-utils/useDisablePageScroll';
import { useBrowserPageIsPageReloadingSelector } from '@/packages/redux-state/store/slices/browserPage';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';
import { getIsBrowserBuild } from '@/packages/utils/isBuildType';

import { ListingLayout } from '../components/ListingLayout/ListingLayout';
import { ListingLoadErrorView } from '../components/ListingLoadErrorView';
import { ListingLoadingView } from '../components/ListingLoadingView';
import { ListingNoCards } from '../components/ListingNoCards';

import { ListingByPinCardsContainer } from './ListingByPinCardsContainer';
import { PaginationByPinContainer } from './PaginationContainer';

export const ListingByPinContainer = memoWithDisplayName(() => {
  const { data, isFetching, refetch, status } = useGetOffersByActivePinQuery();
  const isNarrow = useListingLayoutIsNarrowSelector();
  const isPageReloading = useBrowserPageIsPageReloadingSelector();

  const isListingLoading = (isFetching || isPageReloading) && getIsBrowserBuild();

  useDisablePageScroll(isListingLoading);

  switch (status) {
    case 'loading':
      return <ListingLoadingView isNarrow={isNarrow} />;
    case 'error':
      return (
        <ListingLayout
          cards={null}
          isFetching={isListingLoading}
          isNarrow={isNarrow}
          navigation={<BackToListingButtonContainer />}
          noCardsDump={<ListingLoadErrorView isLoading={isFetching} onRetry={refetch} />}
          pagination={null}
          seo={null}
          similarCards={null}
        />
      );
    case 'success': {
      const { offers } = data;

      return (
        <ListingByPinContextProvider value={data}>
          <ListingLayout
            cards={!!offers.length && <ListingByPinCardsContainer />}
            isFetching={isListingLoading}
            isNarrow={isNarrow}
            navigation={<BackToListingButtonContainer />}
            noCardsDump={<ListingNoCards />}
            pagination={<PaginationByPinContainer />}
            seo={<SEOBlockByPin />}
            similarCards={null}
          />
          <VisitedOffersAnalytics isFetchingOffers={isFetching} offers={offers} />
        </ListingByPinContextProvider>
      );
    }
  }
}, 'ListingByPinContainer');
